import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Button, IconButton, Box, Typography } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getUserProfile, logout } from "../../services/api";
import { storeUser, clearUser } from "../../store/userSlice";

import { resetDataFromBE } from "../../store/dataFromBESlice";
import { setDefaultCI } from "../../store/commericalInvoiceSlice";
import { resetFuelBatchTicket } from "../../store/fuelBatchTicketSlice";
import MenuIcon from "@material-ui/icons/Menu";
import Profile from "./../pages/profile/profile.component";

const Header = ({ onMenuClick, onMenuClick1, sx }) => {
  // custom hook
  const history = useHistory();
  const dispatch = useDispatch();

  // redux state
  const user = useSelector((state) => state.user.data);
  const title = useSelector((state) => state.layout.header_title);

  // state
  const [openProfile, setOpenProfile] = useState(false);

  // effect
  useEffect(() => {
    if (!localStorage.getItem("token")) return history.push("/login");
    getUserProfile()
      .then((res) => {
        if (res.code === 200) {
          dispatch(storeUser({ ...res.data[0], permissions: JSON.parse(res.data[0].permissions || "{}") }));
        } else {
          localStorage.removeItem("token");
          history.push("/login");
        }
      })
      .catch((err) => {
        localStorage.removeItem("token");
        history.push("/login");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = async () => {
    history.push("/login");
    await logout();
    dispatch(clearUser());
    /**
     * Reset state here
     */
    dispatch(resetDataFromBE());
    dispatch(setDefaultCI());
    dispatch(resetFuelBatchTicket());
  };

  return (
    <Box>
      {user && (
        <AppBar sx={sx}>
          <Toolbar>
            <IconButton color="inherit" edge="start" onClick={onMenuClick} sx={{ mr: 2, display: { sm: "flex", md: "flex", lg: "flex", xs: "flex", xl: "none" } }}>
              <MenuIcon />
            </IconButton>
            <IconButton color="inherit" edge="start" onClick={onMenuClick1} sx={{ mr: 2, display: { sm: "none", md: "none", lg: "none", xs: "none", xl: "flex" } }}>
              <MenuIcon />
            </IconButton>
            <Typography style={{ fontSize: 13 }}>{title}</Typography>

            {/* Right Section */}
            <section style={{ marginLeft: "auto", marginRight: -12 }}>
              <Button sx={{ fontSize: "12px", marginLeft: "5px" }} color="secondary" variant="text" onClick={() => setOpenProfile(true)}>
                {user.organization} / {user.department_name}: {user.email}
              </Button>
              <IconButton sx={{ color: "white" }} onClick={() => handleLogout()}>
                {" "}
                <ExitToAppIcon />
              </IconButton>
            </section>
            <Profile open={openProfile} onClose={() => setOpenProfile(false)} />
          </Toolbar>
        </AppBar>
      )}
    </Box>
  );
};

export default Header;
